import loader from './loader';
const MonacoEditor = Vue.defineAsyncComponent(() => import(/*webpackChunkName:"platform_common_codeEditor"*/'./monacoEditor.vue'));
MonacoEditor.loader = loader.load;
export {MonacoEditor};